var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ReactComponent as FacebookIcon } from '../../../resources/assets/components/social-networks/facebook.svg';
import { ReactComponent as InstagramIcon } from '../../../resources/assets/components/social-networks/instagram.svg';
import { ReactComponent as LinkedinIcon } from '../../../resources/assets/components/social-networks/linkedin.svg';
import { ReactComponent as TwitterIcon } from '../../../resources/assets/components/social-networks/twitter.svg';
import { ReactComponent as YoutubeIcon } from '../../../resources/assets/components/social-networks/youtube.svg';
import { Link } from '../link/link.js';
import SocialNetworksAPI from './social-networks-api.js';
import './social-networks.css';
let SocialNetworks = class SocialNetworks extends Component {
    renderIcon(network, Icon) {
        if (!network) {
            return null;
        }
        return (React.createElement(Link, { icon: React.createElement(Icon, null), route: network }));
    }
    render() {
        const { facebook, instagram, linkedin, twitter, youtube } = this.props;
        return (React.createElement("div", { className: "c-social-networks" },
            this.renderIcon(facebook, FacebookIcon),
            this.renderIcon(instagram, InstagramIcon),
            this.renderIcon(linkedin, LinkedinIcon),
            this.renderIcon(twitter, TwitterIcon),
            this.renderIcon(youtube, YoutubeIcon)));
    }
};
SocialNetworks.propTypes = {
    facebook: string,
    instagram: string,
    linkedin: string,
    twitter: string,
    youtube: string,
};
SocialNetworks = __decorate([
    AwesomeComponent({ api: SocialNetworksAPI, type: ComponentType.DATA_DISPLAY })
], SocialNetworks);
export default SocialNetworks;
//# sourceMappingURL=social-networks.js.map